import { useMemo, useState } from 'react';
import { GenericOption, SmartConnector } from '__pages/SmartConnectors/types';

export const useScope = (
  headers: SmartConnector['headers'],
  initialScope?: string
) => {
  const [scope, setScope] = useState<string>(
    initialScope || Object.keys(headers || {})[0]
  );

  const scopeOptions = useMemo(() => {
    return Object.keys(headers || {}).map((scope) => ({
      value: scope,
      label: scope,
    }));
  }, [headers]);

  const onChangeScope = ({ value }: GenericOption) => {
    setScope(value);
  };

  return { scope, setScope, scopeOptions, onChangeScope };
};
